export default __webpack_public_path__ + "static/media/marianareid-marca-CMYK_marianareid-principal-fundo-transparente.2d0aae89.svg";